import React, { useMemo } from "react";
import storage from "../utils/storage";
import AvtarComponent from "./AvatarComponent";

const NameDisplay = ({ toggleThemeVisibility, showAvata = true }) => {
    const userInfo = useMemo(() => {
        const storedUser = storage.get('loginUser');
        return storedUser ? JSON.parse(storedUser) : {}; // Fallback to empty object
    }, []);
    const { userRole = '', siteId = '', firstName = '', lastName = '' } = userInfo;
    return (
        <div  className="flex align-items-center gap-2" onClick={toggleThemeVisibility}>
            <div className="userName" >
                <h5 className="m-0 p-0">{`${firstName} ${lastName}`}</h5>
                <p className="m-0 p-0">{`Site ${siteId} ${userRole}`}</p>
            </div>

            {showAvata && (
                <AvtarComponent username={`${firstName} ${lastName}`}/>
            )}
        </div>
    );
};

export default NameDisplay;

